import * as React from 'react';
import { MiddlewareSync } from "@sa/rep-common";
import { ComponentProcessingState } from "@sa/rep-react";
import { ComponentChart } from "../components/ComponentChart";
import { SlideContext } from "../Context";
import { REPORT_ID } from '../constants';

export const slide15ComponentMiddleware: MiddlewareSync<ComponentProcessingState> = (input, next) => {
  const { identification, componentContext } = input;
  if (REPORT_ID === identification.reportId) {
    if (identification.componentId === "chart") {
      input.component = <ComponentChart context={componentContext as SlideContext}></ComponentChart>;
    }
  }
  return next(input);
};
